
    const server = "https://cms.kwimee.mobi";
    //const server = "http://localhost:4000";


export default server;